(function () {
  'use strict';

  const angular = window.angular;
  ProfileController.$inject = ['$element', '$timeout', '$filter', 'Customer'];

  angular.module('app').component('telegramActiveSessions', {
    template:'<div style="position: relative" ng-style="{opacity: ctrl.loading? 0: 1}"><div class="modal-header"><button type="button" class="close" ng-click="ctrl.modalInstance.dismiss()" aria-hidden="true"><i class="fas fa-times"></i></button> <span>Sesiones de telegram activas</span></div><div class="modal-body"><div><div class="panel panel-default"><div class="dataTable-toolbar paddingT10 paddingB10"><div class="btn-group btn-group-sm"><button class="btn btn-default btn-label disabled" translate>general.actions</button> <button class="btn btn-primary" style="min-width: 90px" ng-click="ctrl.deleteActiveSession()" ng-disabled="!ctrl.selectedTelegramSession"><i class="fas fa-trash"></i> <span translate>buttons.delete</span></button></div></div><div class="paddingLR20 paddingB20 paddingT10"><table id="sessions-table" class="table table-hover no-wrap"><thead><tr><th></th><th></th><th></th><th class="control"></th></tr></thead></table></div></div><div class="alert alert-warning no-margin text-center" ng-if="ctrl.errors.length"><div ng-repeat="error in ctrl.errors">{{error}}</div></div><div class="modal-footer" style="border-top: none"><button class="btn btn-primary" ng-click="ctrl.modalInstance.dismiss()" translate>buttons.done</button></div></div><spinner show="ctrl.loading" show-logo="true"></spinner></div></div>',
    controller: ProfileController,
    controllerAs: 'ctrl',
    bindings: {
      resolve: '<',
      modalInstance: '<',
    },
  });

  function ProfileController($element, $timeout, $filter, Customer) {
    let vm = this;
    vm.$onInit = function () {
      vm.deleteActiveSession = deleteActiveSession;
      initTable(vm.resolve.sessions);
    };

    function initTable(data) {
      if (vm.dtInstance) {
        vm.dtInstance.clear();
        vm.dtInstance.rows.add(data);
        vm.dtInstance.draw();
        return;
      }

      let dtOptions = {
        processing: true,
        paging: false,
        info: false,
        data: data,
        searching: false,
        select: {
          selector: 'td:not(.control)',
          style: 'single',
        },
        columns: [
          {
            data: null,
            orderable: false,
            className: 'select-radio-btn',
            render: checkboxRendered,
            width: '10px',
          },
          {
            data: 'platform',
            //title: $translate.instant('entities.telegram.titles.name'),
            title: 'Plataforma',
            width: 'auto',
          },
          {
            data: 'authDate',
            //title: $translate.instant('entities.telegram.titles.surname'),
            title: 'Fecha de login',
            width: 'auto',
            render: function (data, type, row) {
              return data != null ? $filter('date')(data, 'yyyy-MM-dd HH:mm') : '';
            },
          },
          {
            data: 'expiresAt',
            //title: $translate.instant('entities.telegram.titles.surname'),
            title: 'Fecha de Expiracion',
            width: 'auto',
            render: function (data, type, row) {
              return data != null ? $filter('date')(data, 'yyyy-MM-dd HH:mm') : '';
            },
          },
        ],
      };

      $timeout(() => {
        let table = $element.find('#sessions-table');

        vm.dtInstance = table.DataTable(dtOptions);
        let dtInstance = vm.dtInstance;

        table.find('thead th').removeClass('select-radio-btn');

        dtInstance
          .on('select', function () {
            $timeout(function () {
              vm.selectedTelegramSession = dtInstance.rows({ selected: true }).data().toArray()[0];
            });
          })
          .on('deselect', function () {
            $timeout(function () {
              vm.selectedTelegramSession = null;
            });
          });
      }, 50);
    }
    function checkboxRendered() {
      return '';
    }

    function deleteActiveSession() {
      vm.errors = [];
      vm.resolve.model
        .prototype$MiniAppUserSessionActiveLogout({
          id: vm.resolve.userId,
          sessionId: vm.selectedTelegramSession['_id'],
        })
        .$promise.then((response) => {
          let selectedRow = vm.dtInstance.rows({ selected: true });
          selectedRow.remove().draw(false);
          vm.selectedTelegramSession = null;
        })
        .catch((err) => {
          vm.errors = [err.data.error];
          console.log(err.data.err);
        });
    }
  }
})();
